/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_WarningsInputs */

const cs_import_stat_warnings = /** @type {(inputs: Import_Stat_WarningsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Varování: ${i?.count}`)
};

const en_import_stat_warnings = /** @type {(inputs: Import_Stat_WarningsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Warnings: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Warnings: {count}" |
*
* @param {Import_Stat_WarningsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_warnings = /** @type {((inputs: Import_Stat_WarningsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_WarningsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_warnings(inputs)
	return cs_import_stat_warnings(inputs)
});